export default "__VITE_ASSET__CXC1tsi0__"